import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FaBars, FaTimes } from 'react-icons/fa';
import styles from '../styles/Header.module.css';
import logo from '../assets/logo.webp';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen((prev) => !prev);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className={styles.header}>
      <div className={styles.inner}>
        <img src={logo} alt="Hodson Timber" className={styles.logo} />

        {/* Burger button */}
        <button
          className={styles.burger}
          onClick={toggleMenu}
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
        >
          {menuOpen ? <FaTimes /> : <FaBars />}
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <nav className={styles.mobileNav}>
          <Link to="/" onClick={closeMenu}>
            Home
          </Link>
          {/* <Link to="/services" onClick={closeMenu}>
            Services
          </Link> */}
          <Link to="/contact" onClick={closeMenu}>
            Contact
          </Link>
        </nav>
      )}
    </header>
  );
};

export default Header;